import { render, staticRenderFns } from "./DiseaseAdvices.vue?vue&type=template&id=6b5c4f3a&scoped=true"
import script from "./DiseaseAdvices.vue?vue&type=script&lang=js"
export * from "./DiseaseAdvices.vue?vue&type=script&lang=js"
import style0 from "./DiseaseAdvices.vue?vue&type=style&index=0&id=6b5c4f3a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c4f3a",
  null
  
)

export default component.exports